import React from "react"
import PropTypes from "prop-types"
import { Translate } from "react-localize-redux"
import classNames from "classnames"
import { NavHashLink as NavLink } from "react-router-hash-link"
import profile from "../../images/icons/profile.png"
import Slider from "react-slick"

import Logo from "../../images/logos/new-logo.png"
import { TopMenuButtons, TopMenuLinks } from "../../configs/MenuLinks"

class Header extends React.Component {
	constructor(props) {
		super(props)
		this.state = { width: window.innerWidth }
	}

	componentDidMount() {
		const handleResize = () => {
			// Set window width/height to state
			this.setState({ width: window.innerWidth })
		}
		// Add event listener
		window.addEventListener("resize", handleResize)

		// Call handler right away so state gets updated with initial window size
		handleResize()
	}
	renderMenu = ({ path, title, exact, className }, locale, handleCloseMenu, index) => (
		<li key={index}>
			<NavLink
				activeClassName="active"
				exact={exact}
				onClick={handleCloseMenu}
				to={`/${locale}${path}`}
				className={className}>
				{<Translate id={title} />}
			</NavLink>
		</li>
	)

	render() {
		const { isAuthenticated, isMenuOpen, handleToggleMenu, handleCloseMenu } =
			this.props
		const { width } = this.state

		return (
			<Translate>
				{(translate, activeLanguage, languages) => {
					const locale = activeLanguage.code
					return (
						<header
							id="header"
							className={classNames("container-fluid", {
								"is-open": isMenuOpen,
							})}>
							{width > 1200 && (
								<div className="row align-items-center justify-content-center">
									<div
										className="col-6 col-md-2 logo"
										style={{ justifyContent: "flex-end !important" }}>
										<NavLink
											to={`/${locale}/`}
											onClick={handleCloseMenu}>
											<img
												style={{ width: "138px", height: "auto" }}
												src={Logo}
												alt="Starbucks Rewards logo"
											/>
										</NavLink>
									</div>
									<div
										id="mobileMenuPanel"
										className="col-md-10 mobile-menu-panel">
										<nav className="top-menu">
											{!isAuthenticated && (
												<ul>
													{TopMenuLinks.map((value, index) =>
														this.renderMenu(
															value,
															locale,
															handleCloseMenu,
															index
														)
													)}
													<div
														style={{
															display: "flex",
															alignItems: "center",
														}}>
														<li
															style={{
																marginRight: "8px",
															}}>
															<NavLink
																activeClassName="active"
																exact={true}
																onClick={handleCloseMenu}
																to={`/${locale}/sign-in`}
																style={{
																	whiteSpace: "nowrap",
																	padding: "8px 16px",
																}}
																className="btn btn-small btn-outline-secondary btn-sign-in">
																{
																	<div
																		style={{
																			display:
																				"flex",
																			alignItems:
																				"center",
																		}}>
																		<img
																			src={profile}
																			style={{
																				marginRight:
																					"8px",
																				width: "auto",
																				height: "16px",
																			}}
																		/>
																		<Translate id="header.topMenu._login_signin" />
																	</div>
																}
															</NavLink>
														</li>
													</div>
												</ul>
											)}
										</nav>
									</div>
								</div>
							)}

							{width <= 1200 && (
								<div className="row align-items-center justify-content-center">
									<div
										id="mobileMenuPanel"
										className="mobile-menu-panel">
										<nav className="top-menu">
											{!isAuthenticated && (
												<ul style={{ justifyContent: "center" }}>
													<NavLink
														to={`/${locale}/`}
														onClick={handleCloseMenu}>
														<img
															style={{
																width: "138px",
																height: "auto",
															}}
															src={Logo}
															alt="Starbucks Rewards logo"
														/>
													</NavLink>
													<div
														style={{
															display: "flex",
															alignItems: "center",
														}}>
														<li
															style={{
																marginRight: "8px",
															}}>
															<NavLink
																activeClassName="active"
																exact={true}
																onClick={handleCloseMenu}
																to={`/${locale}/sign-in`}
																style={{
																	whiteSpace: "nowrap",
																	padding: "8px 16px",
																}}
																className="btn btn-small btn-outline-secondary btn-sign-in">
																{
																	<div
																		style={{
																			display:
																				"flex",
																			alignItems:
																				"center",
																		}}>
																		<img
																			src={profile}
																			style={{
																				marginRight:
																					"8px",
																				width: "auto",
																				height: "16px",
																			}}
																		/>
																		<Translate id="header.topMenu._login_signin" />
																	</div>
																}
															</NavLink>
														</li>
													</div>
												</ul>
											)}
											{!isAuthenticated && (
												<div
													className="top-menu"
													style={{
														overflowX: "scroll",
														width: width,
													}}>
													<ul>
														{TopMenuLinks.map(
															(value, index) =>
																this.renderMenu(
																	value,
																	locale,
																	handleCloseMenu,
																	index
																)
														)}
													</ul>
												</div>
											)}
										</nav>
									</div>
								</div>
							)}
						</header>
					)
				}}
			</Translate>
		)
	}
}

Header.propTypes = {
	location: PropTypes.object.isRequired,
	isAuthenticated: PropTypes.bool.isRequired,
	match: PropTypes.object.isRequired,
}

export default Header



// WEBPACK FOOTER //
// ./src/views/layout/Header.js